export default __webpack_public_path__ + "static/media/qr_code_tutorial_step_one.77eb1a3c.png";